// Services.tsx
import ServiceCard from "./ServiceCard";
import { serviceList } from "../data/Services";

const Services: React.FC = () => {
  return (
    <>
      <style>{`
        .sb-services {
          padding: 5rem 0;
          background: #f4f6f9;
          border-top: 0.5px solid rgba(0, 0, 0, 0.08);
        }

        .sb-services-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }

        .sb-services-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 0.75rem;
          font-weight: 600;
          color: #a8b8cc;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          margin: 0 0 0.75rem;
        }

        .sb-services-heading {
          font-family: 'Noto Serif JP', serif;
          font-size: 2rem;
          font-weight: 700;
          color: #263752;
          letter-spacing: -0.02em;
          line-height: 1.2;
          margin: 0 0 2.5rem;
        }

        .sb-services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 1.5rem;
        }

        @media (max-width: 767px) {
          .sb-services {
            padding: 3.5rem 0;
          }

          .sb-services-heading {
            font-size: 1.5rem;
          }
        }
      `}</style>

      <section id="Services" className="sb-services">
        <div className="sb-services-inner">
          <p className="sb-services-label">Services</p>
          <h3 className="sb-services-heading">Everything your business needs to stay financially healthy</h3>
          <div className="sb-services-grid">
            {serviceList.map((section, index) => (
              <ServiceCard key={index} section={section} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;